import type { FC } from "react";
import { useMemo } from "react";

import { ScrollArea } from "@similarweb/ui-components";

import type { IDashboardPptExportListProps } from "pro-features/components/Dashboard/DashboardPptExportModal/DashboardPptExportList/DashboardPptExportListTypes";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { DashboardPptExportListItem } from "./DashboardPptExportListItem";
import { ListContainer } from "./DashboardPptExportListStyles";

export const DashboardPptExportList: FC<IDashboardPptExportListProps> = (props) => {
    const { listItems, onToggleWidgetSelect } = props;

    const listContent = useMemo(() => {
        return listItems.map((item) => {
            return (
                <DashboardPptExportListItem
                    key={item.id}
                    item={item}
                    onToggle={onToggleWidgetSelect}
                />
            );
        });
    }, [listItems, onToggleWidgetSelect]);

    return (
        <ListContainer>
            <ScrollArea
                style={{ height: "261px" }}
                verticalScrollbarStyle={{ borderRadius: 5 }}
                horizontal={false}
                smoothScrolling={true}
                minScrollSize={48}
            >
                <FlexColumn>{listContent}</FlexColumn>
            </ScrollArea>
        </ListContainer>
    );
};
